import React, { Component } from 'react'
import { connect } from 'react-redux'
import { register, toggleModal } from './modalDuck'
import { getModalValue } from './selectors'
import ZenModal from './ZenModal'

class ConnectedModal extends Component {
  componentDidMount() {
    this.props.registerModal()
  }

  render() {
    return <ZenModal {...this.props} />
  }
}

ConnectedModal.defaultProps = {
  startValue: false,
}

const mapStateToProps = (state, ownProps) => ({
  isActive: getModalValue(state, ownProps.name),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  registerModal: () => dispatch(register(ownProps.name, ownProps.startValue)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedModal)
